import React, { useState, useEffect } from 'react';
import HeroImg from '../assets/Malai dp.jpg';
import { AiOutlineMail, AiOutlineLinkedin, AiOutlineGithub } from "react-icons/ai";

function Hero() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [typingSpeed, setTypingSpeed] = useState(150);
    const [cursorVisible, setCursorVisible] = useState(true);

    const titles = [
        'Aspiring Software Developer',
        'Cloud Innovator',
        'Philanthropist',
        'Bibliophile'
    ];

    useEffect(() => {
        // Cursor blinking effect
        const cursorTimer = setInterval(() => {
            setCursorVisible((prev) => !prev);
        }, 500);

        return () => clearInterval(cursorTimer);
    }, []);

    useEffect(() => {
        const currentTitle = titles[currentIndex];

        const handleTyping = () => {
            if (!isDeleting) {
                // Typing characters one by one
                const updatedText = currentTitle.substring(0, text.length + 1);
                setText(updatedText);

                if (updatedText === currentTitle) {
                    setTimeout(() => setIsDeleting(true), 2000); // Pause for 2 seconds
                }
            } else {
                // Deleting characters one by one
                const updatedText = currentTitle.substring(0, text.length - 1);
                setText(updatedText);

                if (updatedText === '') {
                    setIsDeleting(false);
                    setCurrentIndex((prev) => (prev + 1) % titles.length); // Move to the next title
                }
            }
        };

        const timer = setTimeout(handleTyping, typingSpeed);
        return () => clearTimeout(timer);
    }, [text, isDeleting, currentIndex, titles, typingSpeed]);

    const config = {
        social: {
            email: 'mailto:malaiappan59@gmail.com',
            linkedin: 'https://www.linkedin.com/in/s-malaiappan/',
            github: 'https://github.com/Malaiappan59'
        }
    };

    return (
        <section className="flex flex-col px-0 md:py-0 justify-center">
            <div className="flex md:flex-row flex-col bg-[#8C3061] justify-between md:px-44 px-0">
                <div className="flex flex-col pt-20 pl-8">
                    <h1 className="text-white md:text-5xl text-2xl font-hero-font">
                        <div>Hello Folks!</div>
                        <div className="pt-3">I'm Malaiappansrikanth</div>
                        <div
                            className="md:text-lg pt-4 text-base"
                            style={{ height: '2em', display: 'flex', alignItems: 'center' }}
                        >
                            {text}
                            <span
                                className={`ml-1 ${
                                    cursorVisible ? 'opacity-100' : 'opacity-0'
                                }`}
                            >
                                |
                            </span>
                        </div>
                    </h1>
                    <a
                        className="btn bg-[#522258] py-2 px-3 rounded-md my-3 hover:border-2 text-white border-white w-[200px]"
                        target="_blank"
                        href="https://drive.google.com/file/d/1LHCyjsUA7w3SYSWuqjVzK2-Xs5Qg336j/view?usp=sharing"
                        rel="noopener noreferrer"
                    >
                        View My Resume Here
                    </a>
                </div>
                <img
                    className="w-1/2 md:w-[350px] mx-auto md:mx-0 mt-20 md:mt-0 my-0 custom-opacity"
                    style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)' }}
                    src={HeroImg}
                    alt="Profile"
                />
            </div>
            <div className="flex flex-col bg-[#522258] text-center items-center py-16">
                <p className="py-10 text-white text-sm md:text-lg">
                    "Let's change and lead others towards change"
                </p>
                <div className="text-white text-sm md:w-3/5 w-[90%] leading-relaxed">
                    Adaptable Tech-Savvy Specialist proficient in researching, writing, and editing diverse content.
                    Independently produces engaging, authoritative, and error-free work. Enthusiastically seeks to join
                    a dynamic team, eager to learn from seasoned professionals and contribute effectively.
                </div>
                <div className="flex py-10">
                    <a href={config.social.email} target="_blank" className="pr-5 text-[#C63C51] hover:text-white" rel="noopener noreferrer">
                        <AiOutlineMail size={40} />
                    </a>
                    <a href={config.social.linkedin} target="_blank" className="pr-5 text-[#C63C51] hover:text-white" rel="noopener noreferrer">
                        <AiOutlineLinkedin size={40} />
                    </a>
                    <a href={config.social.github} target="_blank" className="text-[#C63C51] hover:text-white" rel="noopener noreferrer">
                        <AiOutlineGithub size={40} />
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Hero;
